/* eslint-disable */
import DirectionEntity from "../Entity/Direction";
import DirectionFactory from "../Factory/Direction";

let DirectionsRepository = Backbone.Collection.extend({
	model: DirectionEntity
});

let repository = new DirectionsRepository();

repository.init = function(options) {
	var directionsModelsArray = [],
		directions = options.directions,
		prices = options.prices;
		_.each(prices, function(category, categoryName) {
			_.each(category, function(value, key) {
				prices[categoryName + '_' + key] = value;
			});
		});
	_.each(directions, function(direction) {
		if (direction?.reference) {
			direction.directionId = `${direction.reference.type}_${direction.reference.id}`;
		}

		var directionModel = new DirectionFactory({
			data:direction,
			prices:prices
		});
		directionsModelsArray.push(directionModel);
	});
	this.set(directionsModelsArray);
};

DirectionsRepository.repository = repository;

export default DirectionsRepository;